module.exports = __webpack_public_path__ + "img/logo-circle.6e02a24a.png";